import { AppEnvironment as Environment } from '@mkp/shared/models';
type EnvironmentName = Environment['name'];

const isEnvNameInArray = (environment: Environment, environmentNames: EnvironmentName[]) =>
  environmentNames.includes(environment.name);

export const getIsDebugActive = (environment: Environment) =>
  isEnvNameInArray(environment, ['local', 'dev', 'qa']);
export const getShouldSyncDebug = (environment: Environment) =>
  isEnvNameInArray(environment, ['local', 'dev', 'qa', 'stage']);
export const getShouldLockDebug = (environment: Environment) =>
  isEnvNameInArray(environment, ['prod']);

export const activeUpToStage = getShouldSyncDebug;
